import { Injectable } from '@angular/core';
import { ComponentEnum, LanguajeEnum } from '@core/enums';

// Importa todos los paquetes de traducción que necesites
import appEn from '@/i18n/app.en.json';
import appEs from '@/i18n/app.es.json';
import homeEn from '@/features/home/i18n/home.en.json';
import homeEs from '@/features/home/i18n/home.es.json';
import summaryEn from '@/features/checkout/components/summary/i18n/summary.en.json';
import summaryEs from '@/features/checkout/components/summary/i18n/summary.es.json';
import creditCardFormEn from '@/features/checkout/components/credit-card-form/i18n/credit-card-form.en.json';
import creditCardFormEs from '@/features/checkout/components/credit-card-form/i18n/credit-card-form.es.json';
import deliveryDataEn from '@/features/checkout/components/delivery-data/i18n/delivery-data.en.json';
import deliveryDataEs from '@/features/checkout/components/delivery-data/i18n/delivery-data.es.json';
import authEn from '@/features/auth/i18n/auth.en.json';
import authEs from '@/features/auth/i18n/auth.es.json';
import resetPasswordEn from '@/features/auth/auth-modal/components/strategies/reset-password-strategy/i18n/reset-password.en.json';
import resetPasswordEs from '@/features/auth/auth-modal/components/strategies/reset-password-strategy/i18n/reset-password.es.json';
import myprofileEn from '@/features/myprofile/i18n/myprofile.en.json';
import myprofileEs from '@/features/myprofile/i18n/myprofile.es.json';
// (SIN USO) TO DO DELETE
// import editprofileEn from '@/features/myprofile/components/editprofile/i18n/editprofile.en.json';
// import editprofileEs from '@/features/myprofile/components/editprofile/i18n/editprofile.es.json';
// import mywalletEn from '@/features/myprofile/components/mywallet/i18n/mywallet.en.json';
// import mywalletEs from '@/features/myprofile/components/mywallet/i18n/mywallet.es.json';
// import orderlistEn from '@/features/myprofile/components/orderlist/i18n/orderlist.en.json';
// import orderlistEs from '@/features/myprofile/components/orderlist/i18n/orderlist.es.json';
import shoppingcartEn from '@/features/shoppingcart/i18n/shoppingcart.en.json';
import shoppingcartEs from '@/features/shoppingcart/i18n/shoppingcart.es.json';
import storesEn from '@/features/storesView/i18n/stores.en.json';
import storesEs from '@/features/storesView/i18n/stores.es.json';
import cardEn from '@/shared/components/card/i18n/card.en.json';
import cardEs from '@/shared/components/card/i18n/card.es.json';
import cartItemsEn from '@/shared/components/cart-items/i18n/cart-items.en.json';
import cartItemsEs from '@/shared/components/cart-items/i18n/cart-items.es.json';
import loadingEn from '@/shared/components/loading/i18n/loading.en.json';
import loadingEs from '@/shared/components/loading/i18n/loading.es.json';
import switchEn from '@/shared/components/switch/i18n/switch.en.json';
import switchEs from '@/shared/components/switch/i18n/switch.es.json';
import notFoundEn from '@/features/not-found/i18n/not-found.en.json';
import notFoundEs from '@/features/not-found/i18n/not-found.es.json';
import soonEn from '@/features/soon/i18n/soon.en.json';
import soonEs from '@/features/soon/i18n/soon.es.json';
import singleproductEn from '@/features/home/components/singleproduct/i18n/singleproduct.en.json';
import singleproductEs from '@/features/home/components/singleproduct/i18n/singleproduct.es.json';
import checkoutEn from '@/features/checkout/i18n/checkout.en.json';
import checkoutEs from '@/features/checkout/i18n/checkout.es.json';
import userInfoFormEn from '@/features/checkout/components/user-info-form/i18n/user-info-form.en.json';
import userInfoFormEs from '@/features/checkout/components/user-info-form/i18n/user-info-form.es.json';
import checkoutHeaderEn from '@/features/checkout/components/checkout-header/i18n/checkout-header.en.json';
import checkoutHeaderEs from '@/features/checkout/components/checkout-header/i18n/checkout-header.es.json';
import myaddressFormEn from '@/features/myprofile/components/addresses/components/myaddress-form/i18n/myaddress-form.en.json';
import myaddressFormEs from '@/features/myprofile/components/addresses/components/myaddress-form/i18n/myaddress-form.es.json';
import menuItemEn from '@/features/home/components/menu-item/i18n/menu-item.en.json';
import menuItemEs from '@/features/home/components/menu-item/i18n/menu-item.es.json';
import tipPromoEn from '@/features/checkout/components/tip-promo/i18n/tip-promo.en.json';
import tipPromoEs from '@/features/checkout/components/tip-promo/i18n/tip-promo.es.json';
import notificationEn from '@/shared/components/notification/i18n/notification.en.json';
import notificationEs from '@/shared/components/notification/i18n/notification.es.json';
import termsConditionsEn from '@/shared/components/terms-conditions/i18n/terms-conditions-modal.en.json';
import termsConditionsEs from '@/shared/components/terms-conditions/i18n/terms-conditions-modal.es.json';
import dialogEn from '@/shared/components/dialog/i18n/dialog.en.json';
import dialogEs from '@/shared/components/dialog/i18n/dialog.es.json';
import { ILanguage, ILanguageObject } from '@core/interfaces';

type I18nModulesMap = {
	[ComponentEnum.SingleProduct]: ILanguage<typeof singleproductEn>;
	[ComponentEnum.Home]: ILanguage<typeof homeEn>;
	[ComponentEnum.Summary]: ILanguage<typeof summaryEn>;
	[ComponentEnum.CreditCardForm]: ILanguage<typeof creditCardFormEn>;
	[ComponentEnum.DeliveryData]: ILanguage<typeof deliveryDataEn>;
	[ComponentEnum.Auth]: ILanguage<typeof authEn>;
	[ComponentEnum.ResetPassword]: ILanguage<typeof resetPasswordEn>;
	[ComponentEnum.MyProfile]: ILanguage<typeof myprofileEn>;
	[ComponentEnum.ShoppingCart]: ILanguage<typeof shoppingcartEn>;
	[ComponentEnum.MultiStore]: ILanguage<typeof storesEn>;
	[ComponentEnum.Card]: ILanguage<typeof cardEn>;
	[ComponentEnum.CartItems]: ILanguage<typeof cartItemsEn>;
	[ComponentEnum.Loading]: ILanguage<typeof loadingEn>;
	[ComponentEnum.Switch]: ILanguage<typeof switchEn>;
	[ComponentEnum.NotFound]: ILanguage<typeof notFoundEn>;
	[ComponentEnum.Soon]: ILanguage<typeof soonEn>;
	[ComponentEnum.Checkout]: ILanguage<typeof checkoutEn>;
	[ComponentEnum.UserInfoForm]: ILanguage<typeof userInfoFormEn>;
	[ComponentEnum.CheckoutHeader]: ILanguage<typeof checkoutHeaderEn>;
	[ComponentEnum.App]: ILanguage<typeof appEn>;
	[ComponentEnum.MyAddressForm]: ILanguage<typeof myaddressFormEn>;
	[ComponentEnum.MenuItem]: ILanguage<typeof menuItemEn>;
	[ComponentEnum.TipPromo]: ILanguage<typeof tipPromoEn>;
	[ComponentEnum.Notification]: ILanguage<typeof notificationEn>;
	[ComponentEnum.TermsConditions]: ILanguage<typeof termsConditionsEn>;
	[ComponentEnum.Dialog]: ILanguage<typeof dialogEn>;
};

@Injectable({ providedIn: 'root' })
export class I18nService<T = unknown> {
	private currentLang: LanguajeEnum = this.getInitialLang();

	I18N_MODULES: I18nModulesMap = {
		[ComponentEnum.SingleProduct]: { en: singleproductEn, es: singleproductEs },
		[ComponentEnum.Home]: { en: homeEn, es: homeEs },
		[ComponentEnum.Summary]: { en: summaryEn, es: summaryEs },
		[ComponentEnum.CreditCardForm]: { en: creditCardFormEn, es: creditCardFormEs },
		[ComponentEnum.DeliveryData]: { en: deliveryDataEn, es: deliveryDataEs },
		[ComponentEnum.Auth]: { en: authEn, es: authEs },
		[ComponentEnum.ResetPassword]: { en: resetPasswordEn, es: resetPasswordEs },
		[ComponentEnum.MyProfile]: { en: myprofileEn, es: myprofileEs },
		// [ComponentEnum.EditProfile]: { en: editprofileEn, es: editprofileEs },
		// [ComponentEnum.MyWallet]: { en: mywalletEn, es: mywalletEs },
		// [ComponentEnum.OrderList]: { en: orderlistEn, es: orderlistEs },
		[ComponentEnum.ShoppingCart]: { en: shoppingcartEn, es: shoppingcartEs },
		[ComponentEnum.MultiStore]: { en: storesEn, es: storesEs },
		[ComponentEnum.Card]: { en: cardEn, es: cardEs },
		[ComponentEnum.CartItems]: { en: cartItemsEn, es: cartItemsEs },

		[ComponentEnum.Loading]: { en: loadingEn, es: loadingEs },
		[ComponentEnum.Switch]: { en: switchEn, es: switchEs },
		[ComponentEnum.NotFound]: { en: notFoundEn, es: notFoundEs },
		[ComponentEnum.Soon]: { en: soonEn, es: soonEs },
		[ComponentEnum.Checkout]: { en: checkoutEn, es: checkoutEs },
		[ComponentEnum.UserInfoForm]: { en: userInfoFormEn, es: userInfoFormEs },
		[ComponentEnum.CheckoutHeader]: { en: checkoutHeaderEn, es: checkoutHeaderEs },
		[ComponentEnum.App]: { en: appEn, es: appEs },
		[ComponentEnum.MyAddressForm]: { en: myaddressFormEn, es: myaddressFormEs },
		[ComponentEnum.MenuItem]: { en: menuItemEn, es: menuItemEs },
		[ComponentEnum.TipPromo]: { en: tipPromoEn, es: tipPromoEs },
		[ComponentEnum.Notification]: { en: notificationEn, es: notificationEs },
		[ComponentEnum.TermsConditions]: { en: termsConditionsEn, es: termsConditionsEs },
		[ComponentEnum.Dialog]: { en: dialogEn, es: dialogEs },
	};

	constructor() {}

	setLanguage(lang: LanguajeEnum): void {
		this.currentLang = lang;
		localStorage.setItem('lang', lang);
	}

	getLanguage(): LanguajeEnum {
		return this.currentLang;
	}

	getTranslations(component: ComponentEnum, lang?: LanguajeEnum): ILanguageObject<T> {
		const language = lang || this.currentLang;

		return this.I18N_MODULES[component]![language] as ILanguageObject<T>;
	}

	private getInitialLang(): LanguajeEnum {
		const saved = localStorage.getItem('lang');
		if (saved) return saved as LanguajeEnum;

		return navigator.language.startsWith(LanguajeEnum.es) ? LanguajeEnum.es : LanguajeEnum.en;
	}
}
